import { render } from "./BaseSpecial.vue?vue&type=template&id=b1a8f0e8&scoped=true"
import script from "./BaseSpecial.vue?vue&type=script&lang=js"
export * from "./BaseSpecial.vue?vue&type=script&lang=js"

import "./BaseSpecial.vue?vue&type=style&index=0&id=b1a8f0e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b1a8f0e8"

export default script